import { createLateInitContext } from "@/shared/hooks/use-late-init-context";

interface IAsideContext {
	afterClick?: () => void;
}

export const AsideContext = createLateInitContext<IAsideContext>();
